module.exports = "/_next/static/images/foresty-dde188573e3e3eb2d916ea5587bda4f0.png.webp";